import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import Loader from "../utils/Loader";

export default function ListarNotifTemplates({ history, match }) {
  const dispatch = useDispatch();

  const modelNotifTemplates = useSelector(
    (state) => state.notifTemplates
  );

  const [notifTemplates, setNotifTemplates] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const data = modelNotifTemplates?.data?.data;
    const error = modelNotifTemplates?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.getNotifTemplatesDuck.actions.clear());
    }
    if (data?.data?.items) {
      setNotifTemplates(data.data.items);
      setTotalResults(data.data.total);
      dispatch(controller.getNotifTemplatesDuck.actions.clear());
    }
  }, [modelNotifTemplates, dispatch]);

  useEffect(() => {
    dispatch(controller.getNotifTemplatesThunk({page: 1, limit: 10}));
  }, []);

  function handlePage(page) {  
    setActivePage(page);
    // const token = localStorage.getItem("token");
    setNotifTemplates([]);
    dispatch(controller.getNotifTemplatesThunk({page: page + 1, limit: pageSize}));
  }

  return (
    <Content
      title="Notificaciones"
      browserTitle="Notificaciones"
      show={false}
    >
      <Row>
        <Col md="10" mdOffset="1">
          <Box title={"Lista"}>
          {/* <Button
              type="primary"
              text="Agregar"
              pullRight={true}
              onClick={() => history.push(`/crearNotificacion`)}
            /> */}
            <div>
              <span>Total: {totalResults}</span>
            </div>
            <Loader isLoading={modelNotifTemplates.loading}>
            {notifTemplates?.length > 0 ? (
              <SimpleTable
              hover={true}
                data={notifTemplates.map((row, index) => {
                  return {
                    titulo: row?.titulo?.substring(0, 50) + '...',
                    mensaje: row?.mensaje?.substring(0, 50) + '...',
                    // accion: row?.accion?.toUpperCase(),
                    tipo: row?.tipo?.toUpperCase(),
                    estado: row?.estado?.toUpperCase(),
                    creado: row?.ts && moment(row.ts).format("DD-MM-YYYY"),
                    actualizado: row.updateTs && moment(row.updateTs).format("DD-MM-YYYY"),
                    editar: (
                      <Button
                        type="primary"
                        text="Editar"
                        size="sm"
                        onClick={() => {
                          history.push("/editarNotificacion/" + row._id);
                        }}
                      />
                    ),
                  };
                })}
                columns={[
                  { title: "Título", data: "titulo" },
                  { title: "Mensaje", data: "mensaje" },
                  // { title: "Acción", data: "accion" },
                  { title: "Tipo", data: "tipo" },
                  { title: "Estado", data: "estado" },
                  { title: "Creado", data: "creado" },
                  { title: "Actualizado", data: "actualizado" },
                  { title: "Editar", data: "editar" },            
                ]}
              />
            ) : (
              <h4>No se han encontrado elementos</h4>
            )}
            </Loader>
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels= {{
                first: 'Primera',
                last: 'Última',
                previous: 'Anterior',
                next: 'Siguiente',
              }}              
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}
